import React from 'react';

export const Contact = ({ data }) => {
  const year = new Date().getFullYear();

  const renderLinks = (links) => {
    return links.map((link, i) => {
      return (
        <li key={`${link.name}-${i}`}>
          <a href={link.url} target="_blank" rel="noopener noreferrer">
            <i className={link.icon}></i>
          </a>
        </li>
      );
    });
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>{data ? renderLinks(data.links) : ''}</ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>&copy; {year} Fredrick Jones</p>
        </div>
      </div>
    </div>
  );
};
